// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupSelect[data-v-59f6f9a9]{position:relative;height:100%}.groupSelect .add[data-v-59f6f9a9]{position:absolute;bottom:0;left:0;right:0;text-align:center;height:34px;line-height:34px;border-top:1px solid #c9cace;cursor:pointer}.groupSelect[data-v-59f6f9a9] .curr-node-opt{position:absolute;right:5px}.groupSelect[data-v-59f6f9a9] .curr-node-opt i{margin-left:5px}", ""]);
// Exports
module.exports = exports;
